export default "__VITE_ASSET__C8Sf5lzq__"